import apiServices from './apiServices'

export default class extends apiServices {
  // Charge l'iban associé au camping
  static loadIban (campingId) {
    return this.get('/api/bank/' + campingId + '/iban', null)
  }

  // ajoute / modifie l'iban associé au compte
  static saveIban (campingId, iban) {
    return this.post('/api/bank/' + campingId + '/iban', iban)
  }
}
